module.exports = __webpack_public_path__ + "media/bgm01.086d649c.mp3";